require('./lbPoiSelect.scss');

const $inject = [];

const lbPoiSelect = {
  controller: 'lbPoiSelectCtrl as vm',
  template: require('./lbPoiSelect.html'),
  bindings: {
    name: '@',
    location: '=',
    defaultOptions: '<?',
    required: '<',
    disabled: '<',
    disablePlaceholder: '<',
    placeholderText: '<?',
    iconClassName: '<?'
  }
};

lbPoiSelect.$inject = $inject;

export default lbPoiSelect;




// WEBPACK FOOTER //
// ./src/components/lbPoiSelect/lbPoiSelect.js